import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box, InputAdornment, Switch, Stepper, Step, StepLabel, Avatar, Autocomplete } from "@mui/material";
// components
import Page from "src/components/Page";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import NavBack from "src/components/common/NavBack";
import { getAreas, getMerchantCategories } from "src/services/request";
import AddressPicker from "src/components/common/AddressPicker";
import { asyncRequest } from "src/services/network";
import Cascader from "src/components/cascader/Cascader";
import FormDialog from "src/components/common/FormDialog";
import SectionHeader from "src/components/section-header/SectionHeader";
import MyDatePicker from "src/components/MyDatePicker";
import dayjs from "dayjs";
// import banks from "src/data/banks.json";
import UserInfo from "src/components/common/UserInfo";
import TiejunPicker from "src/components/common/TiejunPicker";
import UserPicker from "src/components/common/UserPicker";
import BankPicker from "src/components/common/BankPicker";
import MccPicker from "src/components/common/MccPicker";

const steps = ["基础信息", "业务信息", "确认提交"];

// const bizTypes = ['餐饮', '电商平台', '零售', '食品生鲜', '咨询/娱乐票务', '房产中介', '宠物医院', '共享服务', '休闲娱乐/旅游服务', '游艺厅/KTV', '网吧', '院线影城', '演出赛事', '居民生活服务', '景区/酒店', '铁路客运', '机票/票务代理', '培训机构', '保健器械/医疗器械/非处方药品', '其他私立/民营医院/诊所', '其他缴费', '停车缴费', '私立/民营口腔及眼科、医疗美容医院/诊所']

export default function MerchantEdit({ item, onClose, onFinish, isApply }) {
  const { merchantCategories, areas, areaHierarchy, areaMap } = useSelector((state) => state.globalData);

  const navigate = useNavigate();
  const { mid } = item;
  const [category, setCategory] = useState({});
  const [detail, setDetail] = useState(item.detail);
  const [address, setAddress] = useState({
    address: item.address,
  });

  const [area, setArea] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [parent, setParent] = useState(item.parent || {});
  const [agent, setAgent] = useState(item.agent || {});
  const [form, setForm] = useState({
    mid: 0,
    platformCode: item.platformCode || 'huifu',
    businessRole:item.businessRole || 'ACQUIRING',
    type: item.type || 0,
    mobile: item.mobile || "",
    name: item.name || "",
    logo: item.logo || "",
    entrancePic: item.entrancePic || "",
    images: item.images || "",
    username: item.username || "",
    password: item.password || "",
    realname: item.realname || "",
    license: item.license || "",
    intro: item.intro || "",
    // 地理信息
    province: item.province || "",
    city: item.city || "",
    district: item.district || "",
    address: item.address || "",
    isZhiyin: item.isZhiyin || false,
    lng: item.lng || "",
    lat: item.lat || "",

    idCardNoSettle: item.idCardNoSettle || "",
    cardImgFrontSettle: item.cardImgFrontSettle || "",
    cardImgBackSettle: item.cardImgBackSettle || "",
    authEnturstPic: item.authEnturstPic || "",
    mobileSettle: item.mobileSettle || "",

    // 新增
    cardImgFront: item.cardImgFront || "",
    cardImgBack: item.cardImgBack || "",
    idCardNo: item.idCardNo || "",
    idCardAddress: item.idCardAddress || "",
    idCardStartDate: item.idCardStartDate || "",
    idCardEndDate: item.idCardEndDate || "",
    idCardEndDateLong: item.idCardEndDate == "长期" || false,
    licenseStartDate: item.licenseStartDate || "",
    licenseEndDate: item.licenseEndDate || "",
    licenseEndDateLong: item.licenseEndDate == "长期" || false,
    licenseNo: item.licenseNo || "",
    licenseRange: item.licenseRange || "",
    accountName: item.accountName || "",
    accountNumber: item.accountNumber || "",
    accountBank: item.accountBank || "",
    accountBankName: item.accountBankName || "",
    bankDistrictId: item.bankDistrictId || "",
    bankcard: item.bankcard || "",
    email: item.email || "",
    licenseName: item.licenseName || "",
    qualificationType: item.qualificationType || "",

    hfUid: item.hfUid || "",
    provinceId: item.provinceId || null,
    cityId: item.cityId || null,
    districtId: item.districtId || null,

    status: item.status || 1,
    order: item.order || 0,
    rangli: item.rangli || 20,
    discount: item.discount || 10,

    pid: item.pid || null,
    quUid: item.quUid || null,
    cardType: item.cardType != undefined ? item.cardType : 1,
  });

  useEffect(() => {
    getAreas();
    getMerchantCategories();
    checkPlatform()
  }, []);
  useEffect(() => {
    if (!merchantCategories.length || !item.categoryId) return;

    setCategory(merchantCategories.find((it) => it.id == item.categoryId) || {});
  }, [merchantCategories]);

  useEffect(() => {
    if (!areas) return;
    if (!form.provinceId) return;
    const province = areas.find((area) => area.id === form.provinceId);
    const city = areas.find((area) => area.id === form.cityId);
    const qu = areas.find((area) => area.id === form.districtId);
    // setArea(`${province.name}${city.name}${qu.name}`);
  }, [areas, form.districtId]);

  function handleIptChange(ki, val) {
    if(ki=='platformCode'){
      checkPlatform()
    }
    setForm({
      ...form,
      [ki]: val,
    });
  }
  function checkPlatform() {
    if(form.platformCode =='qdkf'){
      return true
    }else{
      return false
    }
  }
  function handleSelectBank() {
    BankPicker({
      onSelect(val) {
        handleIptChange("accountBank", val.name);
      },
    });
  }

  function handleSelectMcc() {
    MccPicker({
      onSelect(val) {
        handleIptChange("qualificationType", val.name);
      },
    });
  }

  async function handleSubmit() {
    // if (!mid && !category.id) return alert("请选择分类");
    // if (!mid && !address) return alert("请选择地址");

    const formData = {
      ...form,
      categoryId: category.id,
      ...address,
    };

    if (mid) {
      formData.mid = mid;

      delete formData.username;
      delete formData.password;
    }

    // 校验
    for (let k in formData) {
      if (typeof formData[k] == "string") {
        formData[k] = formData[k].trim();
      }

      switch (k) {
        case "idCardStartDate":
        case "idCardEndDate":
        case "licenseStartDate":
        case "licenseEndDate":
          formData[k] = dayjs(formData[k]).format("YYYY-MM-DD");
          break;
      }

      if (formData.idCardEndDateLong) {
        formData.idCardEndDate = "长期";
      }

      if (formData.licenseEndDateLong) {
        formData.licenseEndDate = "长期";
      }
    }
    const { data } = await asyncRequest({
      path: mid ? "/merchant/edit" : "/merchant/add",
      data: formData,
    });

    // navigate(-1, { replace: true });
    onFinish();
  }
  return (
    <FormDialog open onClose={onClose} onConfirm={handleSubmit} title={`${mid ? "编辑" : "添加"}商户`}>
      {/* <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper> */}

      <Box sx={{ width: 1000 }}>
        {/* <FormItem title="支付平台" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.platformCode}>
            <FormControlLabel value={'huifu'} control={<Radio />} label="汇付" onChange={(e) => handleIptChange("platformCode", e.target.value)} />
            <FormControlLabel value={'qdkf'} control={<Radio />} label="快付" onChange={(e) => handleIptChange("platformCode", e.target.value)} />
          </RadioGroup>
        </FormItem>
        {checkPlatform() && (
        <FormItem title="快付业务角色" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.businessRole}>
            <FormControlLabel value={'ACQUIRING'} control={<Radio />} label="收单商户" onChange={(e) => handleIptChange("businessRole", e.target.value)} />
            <FormControlLabel value={'SPLIT'} control={<Radio />} label="分账接收方" onChange={(e) => handleIptChange("businessRole", e.target.value)} />
          </RadioGroup>
        </FormItem>
        )} */}
        {/* <FormItem title="商户类型" required>
          <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.type}>
            <FormControlLabel value={0} control={<Radio />} label="个体户" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={1} control={<Radio />} label="企业" onChange={(e) => handleIptChange("type", e.target.value)} />
            <FormControlLabel value={2} control={<Radio />} label="小微" onChange={(e) => handleIptChange("type", e.target.value)} />
          </RadioGroup>
        </FormItem> */}

        {(form.type == 0 || form.type == 1) && (
          <Paper variant="outlined" sx={{ p: 2 }}>
            <SectionHeader title="商户信息" />
            <Grid container>
              <Grid item md={6}>
                <FormItem title="营业执照号" required>
                  <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.type}>
                    <FormControlLabel value={0} control={<Radio />} label="个体户" onChange={(e) => handleIptChange("type", e.target.value)} />
                    <FormControlLabel value={1} control={<Radio />} label="企业" onChange={(e) => handleIptChange("type", e.target.value)} />
                    <FormControlLabel value={2} control={<Radio />} label="小微" onChange={(e) => handleIptChange("type", e.target.value)} />
                  </RadioGroup>
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="主体名称" required>
                  <TextField fullWidth placeholder="请输入主体名称" autoComplete="off" id="licenseName" value={form.licenseName} size="small" onChange={(e) => handleIptChange("licenseName", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="法人姓名" required>
                  <TextField fullWidth placeholder="法人姓名" autoComplete="off" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="法人手机号" required>
                  <TextField fullWidth placeholder="法人手机号" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
                </FormItem>
              </Grid>
            </Grid>
          </Paper>
        )}
        {!mid && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <SectionHeader title="管理员信息" />

            <Grid container>
              <Grid item md={6}>
                <FormItem title="登陆账号" required>
                  <TextField fullWidth placeholder="登陆账号" autoComplete="off" id="username" value={form.username} size="small" onChange={(e) => handleIptChange("username", e.target.value)} />
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem title="登录密码" required>
                  <TextField fullWidth placeholder="登录密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
                </FormItem>
              </Grid>
            </Grid>
          </Paper>
        )}
      </Box>
    </FormDialog>
  );
}
